import { swapSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SwapPage } from "../../features/swap/pages/swap-page";
import { prefetchSdkSwapMetadata } from "../../shared/utils/metadata-data";

export const Route = createFileRoute("/_layout/swap")({
  validateSearch: zodValidator(swapSearchSchema),
  loader: () => {
    // Fire and forget with error handling
    prefetchSdkSwapMetadata().catch(console.warn);
    // Note: We don't prefetch tokens here because we need to know the user's
    // currency preference first, which is only available in component context
    return null; // resolves immediately; route can render
  },
  component: SwapPage,
});
